<form #blockInputs="ngForm">
  <ng-container *ngIf="content.url; else NoImage">
    <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_BLOCK.IMAGE' | translate }}</glxy-label>
    <glxy-form-field>
      <div class="row row-gutters">
        <div class="image-upload-wrapper col col-xs-12 col-sm-6">
          <glxy-image-upload-tile
            [url]="content.url"
            [showDeleteButton]="true"
            [status]="FileUploadStatus.Queued"
            (delete)="clearImage()"
          ></glxy-image-upload-tile>
        </div>
        <div class="image-controls col col-xs-12 col-sm-6">
          <glxy-button-group>
            <a mat-stroked-button [href]="content.url" target="_blank" rel="noopener">
              {{ 'EMAIL_BUILDER.IMAGE_BLOCK.VIEW' | translate }}
            </a>
            <button mat-stroked-button (click)="clearImage()">
              {{ 'EMAIL_BUILDER.IMAGE_BLOCK.CLEAR' | translate }}
            </button>
          </glxy-button-group>
        </div>
      </div>
    </glxy-form-field>
  </ng-container>

  <ng-template #NoImage>
    <div class="title">
      <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_BLOCK.IMAGE' | translate }}</glxy-label>
      <button
        class="image-buttons"
        mat-icon-button
        (click)="openSuggestImageDialog()"
        [glxyTooltip]="'EMAIL_BUILDER.CONTENT_SUGGESTION.GENERATE_IMAGE' | translate"
      >
        <mat-icon svgIcon="galaxy-ai-icon"></mat-icon>
      </button>
    </div>
    <glxy-form-field>
      <glxy-image-uploader
        #imageUploader
        [autoUpload]="true"
        [maxFiles]="1"
        [hintText]="'ADD_SOMETHING_HINT' | translate"
        (fileUploaded)="setImage($event)"
        (fileUploadErrored)="alertFileErrored($event)"
      ></glxy-image-uploader>
    </glxy-form-field>
  </ng-template>

  <div class="row row-gutters">
    <glxy-form-field class="col col-xs-12 col-sm-6">
      <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_BLOCK.IMAGE_STYLE.TEXT' | translate }}</glxy-label>
      <select matInput [(ngModel)]="content.imageStyle" name="Image Style">
        <option value="fullWidth">{{ 'EMAIL_BUILDER.IMAGE_BLOCK.IMAGE_STYLE.FULL_WIDTH' | translate }}</option>
        <option value="center">{{ 'EMAIL_BUILDER.IMAGE_BLOCK.IMAGE_STYLE.CENTER' | translate }}</option>
        <option value="left">{{ 'EMAIL_BUILDER.IMAGE_BLOCK.IMAGE_STYLE.LEFT' | translate }}</option>
        <option value="right">{{ 'EMAIL_BUILDER.IMAGE_BLOCK.IMAGE_STYLE.RIGHT' | translate }}</option>
      </select>
    </glxy-form-field>

    <ng-container *ngIf="content.imageStyle !== 'fullWidth'">
      <glxy-form-field suffixText="px" class="col col-xs-12 col-sm-6">
        <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_BLOCK.WIDTH' | translate }}</glxy-label>
        <input
          matInput
          type="number"
          name="Image Width"
          autocomplete="off"
          inputmode="numeric"
          placeholder="{{ 'PLACEHOLDER_OPTIONAL' | translate }}"
          pattern="[0-9]*"
          [(ngModel)]="content.maxWidth"
          emailHoldShiftToChangeNumberFieldByTen
        />
      </glxy-form-field>
    </ng-container>
  </div>

  <glxy-form-field>
    <glxy-label>{{ 'EMAIL_BUILDER.IMAGE_BLOCK.LINK' | translate }}</glxy-label>
    <input
      matInput
      name="Image Link"
      autocomplete="off"
      placeholder="https://"
      [pattern]="urlMailtoOrDynamicContentRegex"
      [(ngModel)]="content.link"
      #linkUrl="ngModel"
      #link
    />
    <email-dynamic-component-selector
      glxySuffix
      [target]="link"
      [(model)]="content.link"
    ></email-dynamic-component-selector>
    <glxy-error *ngIf="linkUrl.hasError('pattern') && linkUrl.touched">
      {{ 'EMAIL_BUILDER.VALIDATION_ERRORS.LINK' | translate }}
    </glxy-error>
  </glxy-form-field>
</form>
